import React, {FC} from "react";
import {ReactComponent as TsSvg} from "../assets/team-shuffle-text.svg"
import {ReactComponent as AppStoreSvg} from "../assets/app-store.svg"
import iphoneScreenshot from "../assets/iPhone-screenshot.png"
import bg from "../assets/bg.jpg"
import {NavbarMenu} from "../components/NavbarMenu";


export const Hero: FC = () => {
    return (
        <div className="w-full h-screen relative">
            <img className="w-full h-full object-cover blur-sm" alt="bg" src={bg}/>
            <div className="absolute w-full h-full top-0 left-0 bg-black/30 "/>
            <NavbarMenu/>
            <div className="w-full h-screen flex flex-col absolute top-0">
                <div className="grid sm:grid-cols-2 max-w-[1240px] m-auto">
                    <div className="flex flex-col justify-center items-center w-full py-8">
                        <div className="w-full">
                            <TsSvg className="mx-5 pt-5"/>
                        </div>
                        <a href="https://apps.apple.com/app/team-shuffle/id1595503408" className="w-full flex justify-center">
                            <div className="w-full flex justify-center">
                                <AppStoreSvg className="pt-10 md:pt-20 w-[50%]"/>
                            </div>
                        </a>
                    </div>
                    <div className="flex justify-center md:px-10">
                        <img
                            className="object-scale-down w-[60%] max-h-screen"
                            alt="iphone-Screenshot"
                            src={iphoneScreenshot}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

